import style from "./scan-error.module.css";
import { FcCancel } from "react-icons/fc";

const ScanError = ({
	barCode,
	onClose,
	errorMessage = "Error with barcode",
}) => {
	return (
		<div className={style.error_container}>
			<FcCancel size={60} />
			<p>
				{errorMessage}{" "}<br />
				<span>{barCode}</span>
			</p>
			<button type="button" onClick={onClose} style={{cursor: "pointer"}}>
				click to close
			</button>
		</div>
	);
};

export default ScanError;
